/**
 * TKP-118 / tasarım s.24 md.1–6 — Görevler AYRI MODÜL. Ürün ve organizasyon panellerindeki görev ekranları tek modülde
 * (`/tasks`) birleşti; ürün bağlamı ekran içindeki süzgeç oldu (ayrı ürün rotası yok).
 * Eski adresler (12 adet) silinmedi, YÖNLENDİRMEYE çevrildi — yer imleri kırılmasın.
 */
export const tasks = {
  routes: [
    {
      path: "/tasks",
      component: () => import("../organization-tasks"),
    },
    // SIRA ÖNEMLİ: `/tasks/archived` parametreli rotadan ÖNCE gelmeli. Sonra gelirse `/tasks/:id` ile eşleşiyor,
    // ekran görevi "archived" kimliğiyle çekmeye çalışıyor ve `GET /api/task/archived` 500 dönüyordu (arşiv hiç açılmıyordu).
    {
      path: "/tasks/archived",
      component: () => import("../organization-archived-tasks"),
    },
    // TKP-119: modül ayarları — parametreli rotadan ÖNCE (yukarıdaki gerekçe)
    {
      path: "/tasks/settings",
      component: () => import("../task-settings-view"),
    },
    // TKP-122: periyodik görev tanımları — parametreli rotadan ÖNCE
    {
      path: "/tasks/periodic",
      component: () => import("../periodic-tasks-view"),
    },
    // TKP-164: görev panosu (PR #650 analiz ekranı) — parametreli rotadan ÖNCE
    {
      path: "/tasks/dashboard",
      component: () => import("../tasks-dashboard-view"),
    },
    // TKP-118: eski bağlantılar 404 olmasın diye duruyor; TKP-239 g.9: görev e-postasının bağlantısı — tasks.vue `:id`'yi okuyup görevi açar.
    {
      path: "/tasks/:id",
      component: () => import("../organization-tasks"),
    },
  ],
};

/**
 * Kullanıcı panelinin "bana atanan görevler" görünümü. Organizasyon SEÇİLMESİNİ istemez (grup kuralı yalnız `isLoggedIn`) —
 * tasarım s.24 md.2 böyle korunuyor.
 */
export const platform = {
  routes: [
    {
      path: "/account/tasks",
      component: () => import("../account-tasks"),
    },
    // SIRA ÖNEMLİ (yukarıdaki gerekçenin aynısı): sabit `archived` parametreli rotadan önce.
    {
      path: "/account/tasks/archived",
      component: () => import("../account-archived-tasks"),
    },
    {
      path: "/account/tasks/:id",
      component: () => import("../account-tasks"),
    },
  ],
};

// TKP-118: eski ürün/organizasyon görev adresleri → tek görev ekranı. Yönlendirme rotası grubunun kurallarını
// çalıştırmaz; hedef `/tasks` kendi modül kapısıyla (canAccessTasksModule) korunuyor.
export const gdpr = {
  routes: [
    {
      path: "/gdpr/tasks",
      redirect: "/tasks",
    },
    {
      path: "/gdpr/tasks/archived",
      redirect: "/tasks/archived",
    },
  ],
};

export const kvkk = {
  routes: [
    {
      path: "/kvkk/tasks",
      redirect: "/tasks",
    },
    {
      path: "/kvkk/tasks/archived",
      redirect: "/tasks/archived",
    },
  ],
};

export const ddo = {
  routes: [
    {
      path: "/ddo/tasks",
      redirect: "/tasks",
    },
    {
      path: "/ddo/tasks/archived",
      redirect: "/tasks/archived",
    },
  ],
};
export const bgys = {
  routes: [
    {
      path: "/bgys/tasks",
      redirect: "/tasks",
    },
    {
      path: "/bgys/tasks/archived",
      redirect: "/tasks/archived",
    },
  ],
};
export const risk = {
  routes: [
    {
      path: "/risk/tasks",
      redirect: "/tasks",
    },
    {
      path: "/risk/tasks/archived",
      redirect: "/tasks/archived",
    },
  ],
};

export const organization = {
  routes: [
    {
      path: "/organization/tasks",
      redirect: "/tasks",
    },
    {
      path: "/organization/tasks/archived",
      redirect: "/tasks/archived",
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/task-category",
      component: () => import("../task-category/management-library-task-category-view"),
    },
  ],
};
export const workspace = {
  routes: [
    {
      path: "/workspace/library/task-category",
      component: () => import("../task-category/workspace-library-task-category-view"),
    },
  ],
};
